import { defineComponent as _defineComponent } from 'vue'
import useCarouselSpotlight from './utils/useCarouselSpotlight'


export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselTypeSpotlight',
  setup(__props) {

const { collections: spotlight } = useCarouselSpotlight()

return { __sfc: true,spotlight }
}

})